import { DETAIL_INVENTORY } from "../../constants/admin/masterdata/constants";

const initialState = {
  data: null,
  loadingData: true,
  loadingUpdate: false,
  updateSuccess: false,
  error: null,

  loadingBatch: false,
  addBatchSuccess: false,
  batchError: null,

  loadingUpdateBatch: false,
  updateBatchSuccess: false,
  updateBatchError: null,

  historyData: [],
  loadingHistory: false,
  historyTotal: 0,
  historyOffset: 0,
  historyLimit: 10,
  historyBatchCode: "",
  historyError: null,
};

const detailInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case DETAIL_INVENTORY.LOADING_DATA_DETAIL_INVENTORY_SUCCESS:
      return {
        ...state,
        loadingData: action.load,
      };

    case DETAIL_INVENTORY.GET_DATA_DETAIL_INVENTORY_SUCCESS:
      return {
        ...state,
        data: action.data ?? null,
        loadingData: false,
      };

    case DETAIL_INVENTORY.LOADING_ACTION_DETAIL_INVENTORY:
      return {
        ...state,
        loadingUpdate: action.load,
      };

    case DETAIL_INVENTORY.UPDATE_DETAIL_INVENTORY_SUCCESS:
      return {
        ...state,
        updateSuccess: true,
        loadingUpdate: false,
        error: null,
      };

    case DETAIL_INVENTORY.UPDATE_DETAIL_INVENTORY_RESET:
      return {
        ...state,
        updateSuccess: false,
      };

    case DETAIL_INVENTORY.SET_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        error: action.error,
        loadingUpdate: false,
      };

    case DETAIL_INVENTORY.CLEAR_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        error: null,
      };

    case DETAIL_INVENTORY.LOADING_BATCH_DETAIL_INVENTORY:
      return {
        ...state,
        loadingBatch: action.load,
      };

    case DETAIL_INVENTORY.ADD_BATCH_DETAIL_INVENTORY_SUCCESS:
      return {
        ...state,
        addBatchSuccess: true,
        loadingBatch: false,
        batchError: null,
      };

    case DETAIL_INVENTORY.ADD_BATCH_DETAIL_INVENTORY_RESET:
      return {
        ...state,
        addBatchSuccess: false,
      };

    case DETAIL_INVENTORY.SET_BATCH_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        batchError: action.error,
        loadingBatch: false,
      };

    case DETAIL_INVENTORY.CLEAR_BATCH_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        batchError: null,
      };

    case DETAIL_INVENTORY.LOADING_UPDATE_BATCH_DETAIL_INVENTORY:
      return {
        ...state,
        loadingUpdateBatch: action.load,
      };

    case DETAIL_INVENTORY.UPDATE_BATCH_DETAIL_INVENTORY_SUCCESS:
      return {
        ...state,
        updateBatchSuccess: true,
        loadingUpdateBatch: false,
        updateBatchError: null,
      };

    case DETAIL_INVENTORY.UPDATE_BATCH_DETAIL_INVENTORY_RESET:
      return {
        ...state,
        updateBatchSuccess: false,
      };

    case DETAIL_INVENTORY.SET_UPDATE_BATCH_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        updateBatchError: action.error,
        loadingUpdateBatch: false,
      };

    case DETAIL_INVENTORY.CLEAR_UPDATE_BATCH_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        updateBatchError: null,
      };

    case DETAIL_INVENTORY.LOADING_HISTORY_DETAIL_INVENTORY:
      return {
        ...state,
        loadingHistory: action.load,
      };

    case DETAIL_INVENTORY.GET_HISTORY_DETAIL_INVENTORY_SUCCESS:
      return {
        ...state,
        historyData: action.data?.data || [],
        historyTotal: action.data?.total || 0,
        historyOffset: action.data?.offset || 0,
        historyLimit: action.data?.limit || 10,
        historyBatchCode: action.data?.batch_code || "",
        loadingHistory: false,
        historyError: null,
      };

    case DETAIL_INVENTORY.GET_HISTORY_DETAIL_INVENTORY_ERROR:
      return {
        ...state,
        historyError: action.error,
        loadingHistory: false,
      };

    case DETAIL_INVENTORY.CLEAR_HISTORY_DETAIL_INVENTORY:
      return {
        ...state,
        historyData: [],
        historyTotal: 0,
        historyError: null,
      };

    default:
      return state;
  }
};

export default detailInventoryReducer;
